/* Fiber — badge de avaliações sem "salto" de número (v1.0.1)
   O app block do Stamped é renderizado no servidor com o número do metafield reviews.rating_count
   (que pode estar defasado) e, ao carregar, o widget.min.js reescreve o valor com o número atual.
   Isso fazia o contador mudar na frente do cliente. Aqui a legenda ("N avaliações") nasce oculta
   — mantendo o espaço reservado, sem layout shift — e é revelada na primeira reescrita do widget,
   ou por timeout de segurança caso o script do Stamped não responda. */
(function () {
  'use strict';

  var PENDING_CLASS = 'fiber-badge-pending';
  var REVEAL_TIMEOUT = 1500; // fallback: revela mesmo sem resposta do widget
  var SCAN_WINDOW = 10000; // tempo observando novos badges (cards lazy, quick view...)

  function watch(badge) {
    if (badge.dataset.fiberBadgeWatch) return;
    badge.dataset.fiberBadgeWatch = '1';
    badge.classList.add(PENDING_CLASS);

    var timer;
    var observer = new MutationObserver(reveal);

    function reveal() {
      badge.classList.remove(PENDING_CLASS);
      observer.disconnect();
      clearTimeout(timer);
    }

    observer.observe(badge, { childList: true, subtree: true, characterData: true });
    timer = setTimeout(reveal, REVEAL_TIMEOUT);
  }

  function scan() {
    var badges = document.querySelectorAll('.stamped-product-reviews-badge');
    for (var i = 0; i < badges.length; i++) watch(badges[i]);
  }

  function start() {
    scan();

    // badges podem entrar depois (cards com lazy render, quick view, drawer)
    var scheduled = false;
    var pageObserver = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        scan();
      }, 0);
    });

    pageObserver.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { pageObserver.disconnect(); }, SCAN_WINDOW);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
